import { render, staticRenderFns } from "./CollectionTaskReopened.vue?vue&type=template&id=a4ffc816&scoped=true&"
import script from "./CollectionTaskReopened.vue?vue&type=script&lang=js&"
export * from "./CollectionTaskReopened.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ffc816",
  null
  
)

export default component.exports